import {msg} from '@lit/localize';
import {html, LitElement} from 'lit';
import {navigator} from 'lit-element-router';
import {customElement} from 'lit/decorators.js';
import {connect} from 'pwa-helpers';
import {selectLanguage, selectProfileDefaultLanguage} from '../../selectors';
import getRoutes from '../../routes';
import {routeUrl} from '../../util/routeUrl';

import style from '../../../../scss/activityListItem.scss';
import listStyle from '../../../../scss/list.scss';
import store from '../../store';

@customElement('arc-subscription-list-item')
export class SubscriptionListItem extends connect(store)(navigator(LitElement)) {
	static styles = [listStyle, style];

	static properties = {
		subscription: {type: Object},
	};

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = selectLanguage(state);
	}

	static get routes() {
		return getRoutes();
	}
	router(route, params, query, data) {
		this.route = route;
		this.params = params;
	}

	handleEditSubscription() {
		this.navigate(routeUrl('admin-subscription', {...this.params, ...{language: this.lang, subscriptionId: this.subscription.id}}));
	}

	render() {
		return html`
			<div class="listItem">
				<div>${this.subscription.id}</div>
				<div>${this.subscription.accountName}</div>
				<div>${this.subscription.status}</div>
				<div>${this.subscription.provider}</div>
				<div>${this.subscription.trialEndsAt || '-'}</div>
				<div>${this.subscription.scheduledToCancelAt}</div>
			</div>
			<div class="listButtons">
				<arc-dropdown-menu>
					<arc-button
						type="listMenu"
						title="${msg('Edit')}"
						@click=${() => this.handleEditSubscription()}>
						${msg('Edit')}
					</arc-button>
				</arc-dropdown-menu>
			</div>
		`;
	}
}
